import SpriteSymbol from "../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ma_alarm",
  "use": "ma_alarm-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ma_alarm\">\r\n     <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\r\n     <g>\r\n         <path d=\"M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zM17.337 1.811l4.607 3.844-1.281 1.535-4.608-3.843zM6.663 1.81l1.282 1.536L3.337 7.19 2.056 5.654z\" />\r\n         <path d=\"M12 4a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z\" />\r\n     </g>\r\n </symbol>"
});
var result = sprite.add(symbol);
export default symbol